import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {  messaggiHelp } from "./messaggiHelp"

export interface IMessaggioHelp{
  id:number,
  cm:string,
  descrizione?:string
}

@Component({
  selector: 'app-nica-help',
  templateUrl: './nica-help.component.html',
  styleUrls: ['./nica-help.component.css'],

})


export class NicaHelpComponent implements OnInit {

  constructor() { }

  @Input() idHelper?:number; //valori presi in fase di invocazione dei componenti
  @Input() cmHelper:string;
  @Output() clickHelpEmitter :EventEmitter<any>=new EventEmitter(); 
  messaggi : IMessaggioHelp[] = messaggiHelp;
 
  descrizioneDaMostrare?:string;
  idTarget:string="";
  ngOnInit(): void {
   
   
    //Se vengono passati sia l'idHelper sia il codiceMnemonico vado a selezionare 
    if(this.idHelper && this.cmHelper){

      for(let json of this.messaggi){

        if(this.idHelper === json.id){

          setTimeout(() => { //Facciamo passare del tempo altrimenti ci sono problemi e gli helpers appaiono nello stesso punto anche se i pulsanti si trovano in posizioni differenti
            this.idTarget=json.cm+(Math.floor(Date.now()));   
            this.descrizioneDaMostrare=json.descrizione;         
          }, 100);
          
          break;

        }
        
      }
    }
    else{

      for(let json of this.messaggi){

        if(this.idHelper === json.id){

          setTimeout(() => { //Facciamo passare del tempo altrimenti ci sono problemi e gli helpers appaiono nello stesso punto anche se i pulsanti si trovano in posizioni differenti
            this.idTarget=json.cm+(Math.floor(Date.now()));   
            this.descrizioneDaMostrare=json.descrizione;         
          }, 100);
          
          
          break;
        }

        if(this.cmHelper === json.cm){

          setTimeout(() => { //Facciamo passare del tempo altrimenti ci sono problemi e gli helpers appaiono nello stesso punto anche se i pulsanti si trovano in posizioni differenti
            this.idTarget=json.cm+(Math.floor(Date.now()));   
            this.descrizioneDaMostrare=json.descrizione;         
          }, 100);
          
          
          break;

        }
        
      }
    }

  }

  OnButtonInitialized(e){

  }

  isVisibile:boolean=false;

  onClickEmettiHelp(){

    this.isVisibile=true;


    let ris= this.idHelper ? this.idHelper : this.cmHelper;

    //console.warn(ris);

    this.clickHelpEmitter.emit(ris);
  }

}
